// Dispatchers for /ar/services/:slug, /ar/industries/:slug, and /ar/ai-lab.
// Each looks up the slug in its Arabic data table and hands the entry to
// <ArInnerPage />. Missing slugs fall through to <NotFound />.
import { useParams } from "react-router-dom";
import { ArInnerPage } from "@/pages/ar/_ArInnerPage";
import { SERVICES_AR, AI_LAB_AR } from "@/data/services-ar";
import { INDUSTRIES_AR } from "@/data/industries-ar";
import { SOLUTIONS_AR } from "@/data/solutions-ar";
import { WORK_AR } from "@/data/work-ar";
import NotFound from "@/pages/NotFound";

export function ServicePageAr() {
  const { slug } = useParams();
  const node = SERVICES_AR[slug];
  if (!node) return <NotFound />;
  return (
    <ArInnerPage
      {...node}
      serviceWhatsApp
      breadcrumbs={[
        { label: "الرئيسية", to: "/ar" },
        { label: "الخدمات", to: "/ar/services" },
        { label: node.navLabel || node.h1 },
      ]}
    />
  );
}

export function IndustryPageAr() {
  const { slug } = useParams();
  const node = INDUSTRIES_AR[slug];
  if (!node) return <NotFound />;
  const hreflangEn = node.enSlug ? `/industries/${node.enSlug}` : undefined;
  return (
    <ArInnerPage
      {...node}
      hreflangEn={hreflangEn}
      breadcrumbs={[
        { label: "الرئيسية", to: "/ar" },
        { label: "الصناعات", to: "/ar/industries" },
        { label: node.navLabel || node.h1 },
      ]}
    />
  );
}

export function AiLabPageAr() {
  return (
    <ArInnerPage
      {...AI_LAB_AR}
      serviceWhatsApp
      breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "مختبر الذكاء الاصطناعي" }]}
    />
  );
}

export function SolutionPageAr() {
  const { slug } = useParams();
  const node = SOLUTIONS_AR[slug];
  if (!node) return <NotFound />;
  return (
    <ArInnerPage
      {...node}
      breadcrumbs={[
        { label: "الرئيسية", to: "/ar" },
        { label: "الحلول", to: "/ar/solutions" },
        { label: node.navLabel || node.h1 },
      ]}
    />
  );
}

export function CaseStudyPageAr() {
  const { slug } = useParams();
  const node = WORK_AR[slug];
  if (!node) return <NotFound />;
  return (
    <ArInnerPage
      {...node}
      breadcrumbs={[
        { label: "الرئيسية", to: "/ar" },
        { label: "الأعمال", to: "/ar/work" },
        { label: node.navLabel || node.h1 },
      ]}
    />
  );
}
